import { GridOptions } from "@ag-grid-community/core";

import { CurrencyPipe } from "@angular/common";

import { DateCellRendererComponent } from "src/app/ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import { LinkCellRendererComponent } from "src/app/ag-grid-components/link-cell-renderer/link-cell-renderer.component";
import { OrderStatusCellRendererComponent } from "src/app/ag-grid-components/order-status-cell-renderer/order-status-cell-renderer.component";
import { HumanizeDatePipe } from "src/app/pipes/humanize-date.pipe";

const currencyPipe = new CurrencyPipe("en-US");
const humanizeDatePipe = new HumanizeDatePipe("en-US");

export const poColumnDefs: any = [
  {
    field: "poNumber",
    headerName: "PO Number",
    width: 120,
    cellRenderer: "linkCellRendererComponent",
    cellRendererParams: {
      link: (params) => {
        return `/forecasting/purchase-orders/detail/${params.data.poNumber}`;
      },
    },
    //valueGetter: (params) => {
    //  return (Number(params.data.poNumber) || 0).toLocaleString('en');
   //},
  },
  {
    field: "poInvoiceNumber",
    headerName: "Invoice Id",
    width: 120,
  },
  {
    field: "vendorItemName",
    headerName: "Item Name",
    width: 100,
  },
  {
    field: "vendorName",
    headerName: "Vendor",
    width: 120,
  },

      {
        field: "qty",
        headerName: "QTY",
        width: 120,
        valueGetter: (params) => {
          return (Number(params.data.qty) || 0).toLocaleString('en');
       },
      },
      {
        field: "outStandingQty",
        headerName: "Outstanding Qty",
        width: 140,
        valueGetter: (params) => {
          return Number(params.data.qty - params.data.receivedQty).toLocaleString('en');
       },
      },
      {
        field: "price",
        headerName: "Items Cost",
        valueGetter: (params) => {
          return currencyPipe.transform(params.data.price, "USD");
        },
        width: 120,
      },
      {
        field: "totalPrice",
        headerName: "Total Price",
        width: 120,
        valueGetter: (params) => {
          return currencyPipe.transform(params.data.totalPrice, 'USD');
        }
      },
      {
        field: "poDate",
        headerName: "Created",
        valueFormatter: (params) => humanizeDatePipe.transform(params.value, 'MM/dd/yyyy'),
        width: 120,
      },
      {
        field: "status",
        headerName: "Status",
        width: 140,
      },
      {
        field: "submittedBy",
        headerName: "Submitted by",
        width: 120,
      },
      {
        field: "submittedOn",
        headerName: "Submitted on",
        valueFormatter: (params) => params.value ? humanizeDatePipe.transform(params.value, 'MM/dd/yyyy') : '',
        width: 120,
      },
      {
        field: "receivedDate",
        headerName: "Received on",
        valueFormatter: (params) => params.value ? humanizeDatePipe.transform(params.value, 'MM/dd/yyyy') : '',
        width: 120,
      },
      {
        field: "expectedAt",
        headerName: "Expected At",
        valueFormatter: (params) => params.value ? humanizeDatePipe.transform(params.value, 'MM/dd/yyyy') : '',
        width: 120,
      }
];

export const vendorPoColumnDefs = [
  {
    field: "purchaseOrderId",
    headerName: "PO Number",
    width: 120,
    cellRenderer: "linkCellRendererComponent",
    cellRendererParams: {
      link: (params) => {
        return `/forecasting/purchase-orders/detail/${params.data.purchaseOrderId}`;
      },
    },
    sortable:false
  },
  {
    field: "vendorItemName",
    headerName: "Item Name",
    width: 120,
    sortable:false
  },
  {
    field: "vendor",
    headerName: "Vendor",
    width: 120,
    sortable:false
  },

  {
    field: "qty",
    headerName: "QTY",
    width: 120,
    sortable:false
  },
  {
    field: "itemsCost",
    headerName: "Items Cost",
    valueGetter: (params) => {
      return currencyPipe.transform(params.data.itemsCost, "USD");
    },
    width: 120,
    sortable:false
  },
  {
    field: "subTotal",
    headerName: "Total Price",
    width: 120,
    valueGetter: (params) => {
      return currencyPipe.transform(params.data.subTotal, "USD");
    },
    sortable:false
  },
  {
    field: "dateCreated",
    headerName: "Created",
    valueFormatter: (params) =>
      humanizeDatePipe.transform(params.value, "MM/dd/yyyy"),
    width: 120,
    sortable:false
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    cellRenderer:'orderStatusCellRendererComponent',
    sortable:false
  },
  {
    field: "submittedBy",
    headerName: "Submitted by",
    width: 120,
    sortable:false
  },
  {
    field: "dateSubmited",
    headerName: "Submitted on",
    valueFormatter: (params) =>
      params.value
        ? humanizeDatePipe.transform(params.value, "MM/dd/yyyy")
        : "",
    width: 120,
    sortable:false
  },
  {
    field: "recievedDate",
    headerName: "Received on",
    valueFormatter: (params) =>
      params.value
        ? humanizeDatePipe.transform(params.value, "MM/dd/yyyy")
        : "",
    width: 120,
    sortable:false
  },
];

const components = {
  dateCellRendererComponent: DateCellRendererComponent,
  linkCellRendererComponent: LinkCellRendererComponent,
  orderStatusCellRendererComponent:OrderStatusCellRendererComponent
};

export const poGridOptions: GridOptions = {
  rowModelType: "serverSide",
  suppressServerSideInfiniteScroll: false,
  suppressCopyRowsToClipboard: true,
  defaultColDef: {
    resizable: true,
    filterParams: {
      maxNumConditions : 1,
    },
    menuTabs: ["filterMenuTab"],
  },
  components: components,
};
